import { List, Text, Title } from "@mantine/core";
import type { JSX } from "react";

interface IProps {
    context: {
        keywordQuery: string;
        semanticQuery: string;
        hydePassage: string;
        avgRelevance: number;
        documentNames: string[];
    };
}

let docKey = 0;

function RetrievalContext({ context }: IProps): JSX.Element {
    return (
        <>
            <Title order={5}>Keyword query (FTS)</Title>
            <Text>{context.keywordQuery}</Text>
            <Title order={5}>Semantic query (rerank)</Title>
            <Text>{context.semanticQuery}</Text>
            <Title order={5}>HyDE passage (vector search)</Title>
            <Text>{context.hydePassage}</Text>
            <Title order={5}>Average relevance</Title>
            <Text>{context.avgRelevance}</Text>
            <Title order={5}>Documents</Title>
            <List>
                {context.documentNames.map((doc) => (
                    <List.Item key={docKey++}>{doc}</List.Item>
                ))}
            </List>
        </>
    );
}

export default RetrievalContext;
